import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './PolicyDetailsFrame.module.scss'

const propTypes = {
  /**
   * Sanitize checkbox component
   */
  sanitizeCheck: PropTypes.node,
  /**
   * Toggle component
   */
  toggle: PropTypes.node,
  /**
   * Content of the policy details to be rendered
   */
  children: PropTypes.node,
  /**
   * If true, hides header (title) and show toggle in line with content
   */
  headless: PropTypes.bool,
}

function PolicyDetailsFrame(props) {
  const { toggle = null, sanitizeCheck = null, children = null, headless = false } = props ?? {}

  return (
    <div className="text-color-default">
      <div
        className={clsx(headless ? styles.headless : 'd-flex justify-content-between', sanitizeCheck ? 'mb-1' : 'mb-3')}
      >
        {!headless && (
          <div className="text-strong">
            <FormattedMessage id="SECURE.POLICY_DETAILS" />
          </div>
        )}

        <div className={styles.jsonToggleWrapper}>{toggle}</div>
      </div>

      {/* show sanitized elements component */}
      {sanitizeCheck}

      <div>{children}</div>
    </div>
  )
}

PolicyDetailsFrame.propTypes = propTypes

export default PolicyDetailsFrame
